<script setup>
    import { defineProps, defineEmits, onMounted, reactive } from 'vue';
    import { useRoute } from 'vue-router';
    import { getSmtpServerAccounts } from './SmtpServers.access';

    const smtpServer = reactive({
        Name: '',
        ActiveBulk: [],
        ActiveTransactional: [],
    });

    const route = useRoute();

    onMounted(async () => {
        const smtpServerId = route.params.smtpServerId;
        const accounts = await getSmtpServerAccounts(smtpServerId);
        smtpServer.Name = accounts.Name;
        smtpServer.ActiveBulk = accounts.ActiveBulk;
        smtpServer.ActiveTransactional = accounts.ActiveTransactional;
    });
</script>

<template>
    <div>
        <h4>Accounts for SmtpServer ({{ smtpServer.Name }})</h4>
        <div>
            <a
                class="btn btn-xs btn-default position-fixed"
                v-if="smtpServer.ActiveBulk.length > 0 && smtpServer.ActiveTransactional.length > 0"
                href="#active-transactional">
                Go to Transactional
            </a>
        </div>
        <div v-if="smtpServer.ActiveBulk.length === 0">
            <div class="alert alert-info alert-fixed-i">
                <p>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong>Not used</strong>
                    This server is not used for bulk sending.
                </p>
            </div>
        </div>
        <table v-if="smtpServer.ActiveBulk.length > 0" class="table" id="active-bulk">
            <thead>
                <tr>
                    <th>Bulk</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="account in smtpServer.ActiveBulk" :key="account.AccountId">
                    <td>
                        <router-link :to="{ name: 'AccountEdit', params: { accountId: account.AccountId } }">
                            {{ account.Name }}
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="smtpServer.ActiveTransactional.length === 0">
            <div class="alert alert-info alert-fixed-i">
                <p>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong>Not used</strong>
                    This server is not used for transactional sending.
                </p>
            </div>
        </div>
        <table v-if="smtpServer.ActiveTransactional.length > 0" class="table" id="active-transactional">
            <thead>
                <tr>
                    <th>Transactional</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="account in smtpServer.ActiveTransactional" :key="account.AccountId">
                    <td>
                        <router-link :to="{ name: 'AccountEdit', params: { accountId: account.AccountId } }">
                            {{ account.Name }}
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped></style>
